<template>
  <div>
    <template v-if="show">
      <b-sidebar
        id="sidebar-right"
        title="Шинэ"
        right
        shadow
        backdrop
        v-model="showSidebar"
        width="95%"
        @change="visibleChanged"
        :no-close-on-backdrop="true"
        :no-close-on-route-change="true"
        no-header-close
        header-class="pd-0-f wd-100p core-edit-side-header"
      >
        <!-- <template v-slot:header-close>
        <b-icon-x></b-icon-x>
      </template> -->
        <template v-slot:title>
          <nav class="navbar bd-b">
            <span>Шинэ</span>

            <button
              class="btn btn-sm pd-x-15 btn-uppercase mg-l-auto btn-danger"
              @click="visibleChanged(false)"
            >
              <feather type="x" class="mg-r-5"></feather>Хаах
            </button>
          </nav>
        </template>

        <div v-if="ready">
          <div class="container bg-white ht-100p bd-l bd-r">
            <task-edit
              :prms.sync="taskEdit"
              :show.sync="taskEdit.show"
              @on-edit-close="editClosed"
              @on-task-posted="taskPosted"
            ></task-edit>
            <b-overlay :show="handleLoading" rounded="sm">
              <div v-show="currentTab == 1">
                <Form ref="formValidate" :model="taskModel" label-width="30%">
                  <template v-for="(field, i) in fields">
                    <template v-if="field.flag === 1">
                      <FormItem
                        :rules="field.rule"
                        :label="field.title"
                        :prop="field.field"
                        :key="`lbl_${i}`"
                      >
                        <Input
                          :placeholder="field.info"
                          v-model="$data['taskModel'][field.field]"
                        />
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 2">
                      <FormItem
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                        :key="`lbl_${i}`"
                      >
                        <Input
                          v-model="$data['taskModel'][field.field]"
                          type="textarea"
                          placeholder="..."
                        />
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag == 3">
                      <FormItem
                        :key="`lbl_${i}`"
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                      >
                        <loc-type-cascader
                          :id.sync="$data['taskModel'][field.field]"
                          v-model="$data['taskModel'][field.field]"
                          :getParentType="true"
                          :locTypekey.sync="field.key"
                          :disabled="
                            taskModel.objectTypeId == 411 && taskModel.id != 0
                          "
                        />
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 6">
                      <template v-if="taskModel.objectTypeId === 60">
                        <template v-if="taskModel.flag1 === 9900">
                          <FormItem
                            v-if="[field.field] != 'dueStartDate'"
                            :label="field.title"
                            :prop="field.field"
                            :key="`lbl_${i}`"
                            :rules="field.rule"
                          >
                            <DatePicker
                              v-model="$data['taskModel'][field.field]"
                              placeholder="Огноо сонгоно уу"
                              type="datetime"
                              style="width: 100%"
                            ></DatePicker>
                            <div class="text-muted tx-11 eddt-title-info">
                              {{ infoBuilder(field.info) }}
                            </div>
                          </FormItem>
                        </template>
                        <FormItem
                          v-else
                          :label="field.title"
                          :prop="field.field"
                          :key="`lbl_${i}`"
                          :rules="field.rule"
                        >
                          <DatePicker
                            v-model="$data['taskModel'][field.field]"
                            placeholder="Огноо сонгоно уу"
                            type="datetime"
                            style="width: 100%"
                          ></DatePicker>
                          <div class="text-muted tx-11 eddt-title-info">
                            {{ infoBuilder(field.info) }}
                          </div>
                        </FormItem>
                      </template>
                      <FormItem
                        v-else
                        :prop="field.field"
                        :label="field.title"
                        :key="`lbl_${i}`"
                        :rules="field.rule"
                      >
                        <DatePicker
                          v-model="$data['taskModel'][field.field]"
                          placeholder="Огноо сонгоно уу"
                          type="datetime"
                          style="width: 100%"
                        ></DatePicker>
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 8">
                      <Divider :key="`dvdr${i}`">{{ field.title }}</Divider>
                    </template>
                    <template v-else-if="field.flag === 15">
                      <FormItem
                        :key="`lbl_${i}`"
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                      >
                        <InputNumber
                          v-model="$data['taskModel'][field.field]"
                        ></InputNumber>
                        <span
                          class="text-muted p-l-sm"
                          v-if="$data['taskModel'][field.field] > 999"
                          >{{
                            $data["taskModel"][field.field]
                              | formatMoney(0, ".", ",")
                          }}</span
                        >
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 18">
                      <FormItem
                        :key="`lbl_${i}`"
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                      >
                        <!-- <div style="clear:both"></div> -->
                        <summernote
                          v-if="!$store.state.app.isMobile"
                          v-model="$data['taskModel'][field.field]"
                          :text="$data['taskModel'][field.field]"
                        ></summernote>
                        <Input
                          v-else
                          v-model="$data['taskModel'][field.field]"
                          type="textarea"
                        />
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 36">
                      <span :key="`lbl_${i}`" style="display:none">{{
                        ($data["taskModel"]["parentId"] = 0)
                      }}</span>
                    </template>
                    <template v-else-if="field.flag === 39"></template>
                    <template v-else-if="field.flag === 50">
                      <FormItem
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                        :key="`lbl_${i}`"
                      >
                        <div v-if="prms.parentTask != undefined">
                          <span style="display:none">{{
                            ($data["taskModel"][field.field] =
                              prms.parentTask.id)
                          }}</span>
                        </div>
                        <task-finder
                          v-model="$data['taskModel'][field.field]"
                          :selectedId="$data['taskModel'][field.field]"
                          @on-task-selected="field.cstmFld2 = $event.task"
                          :objectTypeId.sync="[field.key][0]"
                          :key="`tsk_${i}`"
                        ></task-finder>
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 51">
                      <FormItem
                        :key="`lbl_${i}`"
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                      >
                        <loctype-multiple-tag
                          v-model="$data['taskModel'][field.field]"
                          :ids.sync="$data['taskModel'][field.field]"
                          :lkey.sync="
                            field.key + '_' + $data['taskModel']['projectId']
                          "
                        ></loctype-multiple-tag>
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 70">
                      <FormItem
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                        :key="`lbl_${i}`"
                      >
                        <simple-uploader
                          v-model="$data['taskModel'][field.field]"
                          :propBoxId="0"
                          :propObjectId="'0'"
                          :propObjectTypeId="$data['taskModel']['objectTypeId']"
                          @on-success="fileUploaded($event, field)"
                        >
                          <div slot="trigger" style="position: relative">
                            <i
                              class="ivu-icon ivu-icon-ios-cloud-upload-outline m-r-xs"
                              style="font-size: 20px; "
                            ></i>
                            <span v-if="$data['taskModel'][field.key] === ''"
                              >Энд дарж файлаа үүсгэнэ үү.</span
                            >
                            <span v-else>
                              {{ $data["taskModel"][field.key] }}
                              <span
                                style="cursor:pointer; position: absolute; right: 5px; top: 5px; padding: 0px;"
                                class="p-md"
                                @click.prevent.stop="
                                  $data['taskModel'][field.field] = null;
                                  $data['taskModel'][field.key] = '';
                                "
                              >
                                <i
                                  class="ivu-icon ivu-icon-md-close m-t-n-md"
                                  style="color:red; font-size: 16px"
                                ></i>
                              </span>
                            </span>
                          </div>
                        </simple-uploader>
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 76">
                      <FormItem
                        :prop="field.field"
                        :label="field.title"
                        :key="`lbl_${i}`"
                        :rules="field.rule"
                      >
                        <DatePicker
                          v-model="$data['taskModel'][field.field]"
                          placeholder="Огноо сонгоно уу"
                          type="date"
                          style="width: 100%"
                        ></DatePicker>
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 83">
                      <FormItem
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                        :key="`lbl_${i}`"
                      >
                        <vet-client-user-org-selecter
                          :selectedId="$data['taskModel'][field.field]"
                          v-model="$data['taskModel'][field.field]"
                        ></vet-client-user-org-selecter>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 85">
                      <FormItem
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                        :key="`lbl_${i}`"
                      >
                        <task-finder
                          v-model="$data['taskModel'][field.field]"
                          :selectedId="$data['taskModel'][field.field]"
                          @on-task-selected="field.cstmFld2 = $event.task"
                          :objectTypeId.sync="[field.key][0]"
                          :key="`tsk_${i}`"
                        ></task-finder>
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else-if="field.flag === 87">
                      <FormItem
                        :rules="field.rule"
                        :prop="field.field"
                        :label="field.title"
                        :key="`lbl_${i}`"
                      >
                        <task-finder
                          v-model="$data['taskModel'][field.field]"
                          :selectedId="$data['taskModel'][field.field]"
                          @on-task-selected="
                            field.cstmFld2 = $event.task;
                            $data['taskModel']['task'] = $event.task;
                          "
                          :objectTypeId.sync="[field.key][0]"
                          :key="`tsk_${i}`"
                        ></task-finder>
                        <div class="text-muted tx-11 eddt-title-info">
                          {{ infoBuilder(field.info) }}
                        </div>
                      </FormItem>
                    </template>
                    <template v-else>
                      <!-- <div :key="`ddr${i}`">{{field.flag}} ::::: {{ field }}</div> -->
                    </template>
                  </template>
                </Form>
              </div>
              <div v-show="currentTab == 2">
                <template v-for="(b, i) in taskDetail.b">
                  <loader
                    :ref="`box_${b.id}`"
                    :key="`b_${i}`"
                    :box="b"
                    :parentTask="taskDetail"
                    :prms="{ boxChooser: false }"
                    @show-edit="editShow($event)"
                  />
                </template>
              </div>
            </b-overlay>
          </div>
        </div>
        <template v-slot:footer>
          <div class="d-flex justify-content-around bd-t container">
            <div v-if="boxCount == 0">
              <b-button @click="onSubmit(1)" variant="primary">
                <b-icon icon="pencil"></b-icon>Хадгалах
              </b-button>
            </div>
            <ul v-else class="steps steps-sm">
              <li class="step-item" :class="{ active: currentTab == 1 }">
                <a @click="currentTab = 1" class="step-link" role="button">
                  <span class="step-number">1</span>
                  <span class="step-title">Үндсэн мэдээлэл</span>
                </a>
              </li>
              <li class="step-item" :class="{ active: currentTab == 2 }">
                <a @click="onSubmit(1)" class="step-link" role="button">
                  <span class="step-number">2</span>
                  <span class="step-title">Бүрдэл</span>
                </a>
              </li>
              <li class="step-item">
                <a
                  @click="onSubmit(currentTab)"
                  class="step-link"
                  role="button"
                >
                  <span class="step-number">3</span>
                  <span class="step-title">{{
                    currentTab === 1 ? "Үргэлжлүүлэх" : "Хадгалах хаах"
                  }}</span>
                </a>
              </li>
            </ul>
            <!-- <b-button size="sm" @click="hide">Close</b-button> -->
          </div>
        </template>
      </b-sidebar>
    </template>
  </div>
</template>

<script>
const moment = require("moment");

import { request } from "@/api/all";
import { getEditFields } from "@/api/taskCore";
import { getInheritedTask, postInheritedTask } from "@/api/task";

import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import "element-ui/lib/theme-chalk/index.css";
import {
  Form,
  Input,
  FormItem,
  DatePicker,
  Divider,
  InputNumber
} from "element-ui";

//import { mapActions } from "vuex";
import loader from "@/components/box/loader/loader.vue";
export default {
  name: "editBase",
  components: {
    Form,
    FormItem,
    Input,
    DatePicker,
    Divider,
    InputNumber,
    loader,
    taskEdit: () => ({
      component: import("@/components/task/edit/base"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    taskFinder: () => ({
      component: import("@/components/task/edit/components/taskFinder"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    vetClientUserOrgSelecter: () => ({
      component: import(
        "@/components/task/edit/components/vetClientUserOrgSelecter"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    locTypeCascader: () => ({
      component: import("@/components/task/edit/components/locTypeCascader"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    loctypeMultipleTag: () => ({
      component: import("@/components/task/edit/components/locTypeMultipleTag"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    simpleUploader: () => ({
      component: import("@/components/modules/media/simpleUploader.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    summernote: () => ({
      component: import("@/components/modules/editor/summernote"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  data: () => ({
    showSidebar: false,
    fields: [],
    ready: false,
    taskModel: {},
    taskDetail: {},
    taskId: 0,
    currentTab: 1,
    savedResponse: {},
    globalError: false,
    directClose: false,

    taskEdit: {
      id: 0,
      show: false,
      render: false,
      objectTypeId: 0,
      projectId: 0,
      parentId: 0,
      parentTask: {}
    },
    handleLoading: false,
    boxCount: 0
  }),
  props: {
    show: {
      type: Boolean,
      default: () => false
    },
    prms: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.showSidebar = true;
      this.taskId = this.prms.id;
      this.build();
    },
    build() {
      let self = this;
      getEditFields({
        params: { objectTypeId: this.prms.objectTypeId },
        store: this.$store
      }).then(res => {
        if (res != false) {
          res.data.fields
            .filter(x => x.flag === 85)
            .forEach(e => {
              e.cstmFld1 = false;
            });

          this.fields = res.data.fields;
          if (this.fields.length == 0) {
            this.$bvToast.toast(`Шинэ мэдээлэл оруулах боломжгүй байна.`, {
              title: "Мэдэгдэл",
              autoHideDelay: 3000,
              appendToast: true,
              variant: "warning",
              toaster: "b-toaster-bottom-left"
            });
            this.visibleChanged(false);
          }
          getInheritedTask({
            params: {
              id: this.prms.id,
              parentId: this.prms.parentId,
              boxId: this.prms.boxId,
              objectTypeId: this.prms.objectTypeId,
              projectId: this.prms.projectId
            },
            store: this.$store
          }).then(res => {
            //console.log(this.prms.id, this.prms.objectTypeId);
            if (this.prms.id == 0 && this.prms.objectTypeId == 138) {
              //console.log(res.data.task.userRegisterOptionModel)
              res.data.task.userRegisterOptionModel = {
                approveRequiredGroupInUser: false,
                approveRequired: false,
                hasDefaultPassword: true,
                disableApproveMail: true
              };
              res.data.task.systemFlag = 1;
              //console.log(res.data.task.userRegisterOptionModel)
            }
            this.taskModel = res.data.task;

            this.fields
              .filter(x => x.dataTypeId === 5)
              .forEach(e => {
                if (self.taskModel[e.field] != null) {
                  self.taskModel[e.field] = moment(
                    self.taskModel[e.field]
                  ).toDate();
                }
              });

            if (this.fields.filter(x => x.flag === 39).length > 0) {
              let fld = this.fields.filter(x => x.flag === 39)[0];
              let prj = this.$store.state.app.groupDefaultProjects.filter(
                x => x.objectTypeId == parseInt(fld.key, 10)
              );
              if (prj.length > 0) this.taskModel.projectId = prj[0].id;
            }

            if (this.prms.id == 0) {
              this.ready = true;
            } else {
              request({
                api: { url: "task/taskInheritedDetail", method: "get" },
                params: { id: this.prms.id },
                store: this.$store
              }).then(res => {
                if (res != false) {
                  this.taskDetail = res.data.task;
                  this.boxCount = this.taskDetail.b.length;
                  // if(==0){

                  // }
                  this.ready = true;
                  //console.log(res);
                } else {
                  this.globalError = true;
                }
              });
            }
          });
        }
      });
    },
    infoBuilder(v) {
      if (v == null) {
        return "";
      } else if (v.length <= 0) {
        return "";
      } else {
        return v;
      }
    },
    fileUploaded(e, field) {
      field.uv = false;
      this.$data["taskModel"][field.key] = e.uploadedName;
      this.$data["taskModel"][field.field] = e.uploadedAttachmentId;
      field.cstmFld1 = e.uploadedUrl;
    },
    onSubmit(submitMode) {
      this.handleLoading = true;

      if (submitMode == 2) {
        this.handleLoading = false;
        this.$emit("on-task-posted", {
          obj: this.savedResponse,
          prms: this.prms
        });
      } else {
        this.$refs.formValidate.validate(valid => {
          if (valid) {
            postInheritedTask({
              data: { model: this.taskModel },
              store: this.$store
            }).then(res => {
              if (res != false) {
                if (res.result == 1) {
                  this.directClose = true;

                  if (submitMode == 1) {
                    this.taskModel.id = res.taskId;

                    this.savedResponse = res;
                    this.taskId = res.taskId;
                    if (this.prms.id == 0) {
                      request({
                        api: { url: "task/taskInheritedDetail", method: "get" },
                        params: { id: this.taskId },
                        store: this.$store
                      }).then(res => {
                        this.handleLoading = false;
                        if (res != false) {
                          this.taskDetail = res.data.task;
                          if (this.taskDetail.b.length == 0) {
                            this.handleLoading = false;
                            this.$emit("on-task-posted", {
                              obj: this.savedResponse,
                              prms: this.prms
                            });
                          } else {
                            this.boxCount = this.taskDetail.b.length;
                            this.currentTab = 2;
                          }
                        } else {
                          this.globalError = true;
                        }
                      });
                    } else {
                      this.handleLoading = false;
                      if (this.boxCount == 0) {
                        this.$emit("on-task-posted", {
                          obj: this.savedResponse,
                          prms: this.prms
                        });
                      } else {
                        this.currentTab = 2;
                      }
                    }
                  } else if (submitMode == 2) {
                    this.handleLoading = false;
                    this.$emit("on-task-posted", {
                      obj: this.savedResponse,
                      prms: this.prms
                    });
                  }
                }
              } else {
                Object.assign(this.$data, this.$options.data());
                this.$emit("on-edit-close");
              }
            });
          } else {
            this.handleLoading = false;
            this.$bvToast.toast(
              `* тэмдэглэгээтэй заавал бөглөх талбаруудыг бөглөнө үү!`,
              {
                title: "заавал бөглөх талбар",
                autoHideDelay: 100,
                appendToast: true,
                variant: "warning",
                toaster: "b-toaster-bottom-left"
              }
            );
          }
        });
      }
    },
    visibleChanged(e) {
      if (!e) {
        if (this.directClose) {
          this.$emit("on-task-posted", {
            obj: this.savedResponse,
            prms: this.prms
          });
        }
        Object.assign(this.$data, this.$options.data());
        this.$emit("on-edit-close");
      }
    },
    editClosed() {
      this.taskEdit.show = false;
      this.taskEdit.id = 0;
    },
    editShow(e) {
      //console.log(e);
      //this.obj.data.task.id
      this.taskEdit.id = e.id;
      this.taskEdit.objectTypeId = e.objectTypeId;
      this.taskEdit.projectId = e.projectId;
      if (e.mode == 2) {
        this.taskEdit.boxId = e.boxId;
        this.taskEdit.parentId = this.taskDetail.id;
        this.taskEdit.parentTask = this.taskDetail;
      }
      this.taskEdit.render = true;
      this.$nextTick(function() {
        this.taskEdit.show = true;
      });
    },
    taskPosted(e) {
      if (e.prms.boxId != undefined) {
        if (this.$refs["box_" + e.prms.boxId].length > 0) {
          this.$refs["box_" + e.prms.boxId][0].reInit(e);
        }
        this.editClosed();
      } else {
        //else ooroo ooriigoo zasaagui
        //this.editClosed();
        //this.init();
      }
    }
  }
};
</script>
<style>
.core-edit-side-header > strong {
  display: block;
  width: 100%;
}
</style>
